
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/in-person-events",
      function () {
        return require("private-next-pages/events/in-person-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/in-person-events"])
      });
    }
  